// extracted by mini-css-extract-plugin
module.exports = {"ogofn2z":"ogofn2z","h1lzu55c":"h1lzu55c","w3yqzrt":"w3yqzrt","dvotazs":"dvotazs","m4eo545":"m4eo545","cwowb9x":"cwowb9x","fxm7j8g":"fxm7j8g"};